export default "__VITE_ASSET__fdb360a3__"